
export default {
    name: 'JobQuoteBookingRow',
    props: {
        isAutoQuote: {
            type: Boolean,
            default: false,
        },
        /**
         * Job Object
         */
        job: {
            type: Object,
            required: true,
        },
    },
    computed: {
        image() {
            if (this.job.images.length) {
                return this.job.images[0].small;
            }
            return `/images/jobs/${this.job.service.slug}.svg`;
        },
    },
};
